<template>
	<Application :title="$t('text.ticketCategories')" :loading="loading" :errorDetail="errorDetail" v-model:errorTitle="errorTitle">
		<template #navbar>
			<v-text-field variant="outlined" density="compact" clearable hide-details
				prepend-inner-icon="mdi-magnify"
				:placeholder="$t('text.searchTicketCategory')"
				style="max-width:33%; height:48px" 
				v-model="searchString" 
				@keyup.enter="offset=0;search()"
				@click:clear="clearSearch()"
				data-cy="search"
			/>
			<v-spacer/>
			<v-btn class="gradientButton" elevation="0" data-cy="addNew" @click="showNewTicketCategory()"><v-icon>mdi-plus</v-icon>{{$t('text.addTicketCategory')}}</v-btn>
		</template>

		<SideBar :navigation="sections" @action="handleAction($event)" />

		<!-- Ticket Category List -->
		<v-card class="tableCard" style="margin-left: 300px;">
			<v-data-table fixed-header disable-sort
				:headers="headers"
				:items="ticketCategories"
				:items-per-page="limit"
				:item-value="item => item"
			>
				<template v-slot:item="{ item }">
					<tr>
						<td @click="showCategoryDetails(item)">{{ item.fields.title[selectedLocale] }}</td>
						<td>
							<mys-switch
								v-model="item.defaultAssignment"
								:label="$t('text.default')"
								@update:modelValue="isChangeDefault = true; checkOptionsProduct(item, 'reduction')"
								style="width: 150px;"
							/>
						</td>
					</tr>
				</template>
				<template #bottom>
					<TablePaginator v-model="offset" :limit="limit" :results="ticketCategories" :total="ticketCategoryCount" @update:modelValue="onPaginate()" />
				</template>
			</v-data-table>
		</v-card>

		<TicketOptionProductsDialog
			ref="ticketOptionProductsDialog"
			:optionProducts="ticketOptionProducts"
			:serviceLocale="serviceLocale"
			@confirm="onOptionProductWarningConfirmed"
			@cancel="onOptionProductWarningCancelled"
		/>
	</Application>
</template>

<script>
import Loading from 'vue-loading-overlay'
import Common from '@/mixins/Common.vue'
import SettingsMixin from '@/mixins/SettingsMixin.vue'
import SideBar from "@/components/common/SideBar.vue"
import Alert from '@/components/common/Alert.vue'
import Disclosure from '@/components/common/Disclosure.vue'
import LanguageFlag from '@/components/common/LanguageFlag.vue'
import TablePaginator from '@/components/common/TablePaginator.vue'
import Application from '../Application.vue'
import TicketOptionProductsDialog from './TicketOptionProductsDialog.vue'

export default {
	mixins: [ Common, SettingsMixin ],
	components: { Loading, SideBar, Alert, Disclosure, LanguageFlag, TablePaginator, Application, TicketOptionProductsDialog },
	data() {
		return {
			loading: false,
			errorTitle: '',
			errorDetail: '',
			ticketCategories: [],
			ticketCategoryCount: 0,
		}
	},

	computed: {
		headers() {
			return [
				{ title: this.$t('text.category'), align: 'left', sortable: true, key: 'item_type' },
				{ title: this.$t('text.default'), key: 'item_default', width:'100px', align:"right" },
			]
		},
	},
	methods: {
		async getReductions() {
			this.loading = true
			try {
				const res = await this.$httpGet(`/client-option?client=${this.$store.state.selectedClient.sys.id}&type=reduction&locale=${this.selectedLocale}&skip=${this.offset}&limit=${this.limit + 1}`)
				this.ticketCategories = res.options ?? []
				this.ticketCategoryCount = res.total

				this.$store.state.selectedClient.fields.reductions.de = this.ticketCategories
			}
			catch (error) {
				this.errorTitle = this.$t('text.ERROR')
				this.errorDetail = error.response?.data?.error ?? error
			}
			this.loading = false
		},
		async search() {
			this.offset = 0
			await this.searchReductions()
		},
		async searchReductions() {
			this.loading = true
			try {
				let url = `/search-options?clientId=${this.$store.state.selectedClient.sys.id}`
				url += `&type=reduction`
				url += `&locale=${this.selectedLocale}`
				url += `&skip=${this.offset}`
				url += `&limit=${this.limit + 1}`
				url += `&searchString=${encodeURIComponent(this.searchString)}`

				const res = await this.$httpGet(url)
				this.ticketCategories = res.options ?? []
				this.ticketCategoryCount = res.total ?? 0
			}
			catch (error) {
				this.errorTitle = this.$t('text.ERROR')
				this.errorDetail = error.response?.data?.error ?? error
			}
			this.loading = false
		},
		clearSearch() {
			this.searchString = ''
			this.offset = 0
			this.getReductions()
		},
		showNewTicketCategory() {
			this.$router.push(`/reductionDetails`)
		},
		showCategoryDetails(item) {
			this.$router.push(`/reductionDetails?ticketCategoryId=${item.sys.id}`)
		},
		onPaginate() {
			if (this.searchString?.length > 0) {
				this.searchReductions()
			} else {
				this.getReductions()
			}
		},
	},
	mounted() {
		this.state = 'categories'
		this.activeLink = 'categories'
		this.setSections()
		this.getReductions()
	},
}
</script>

<style lang="scss" scoped>
.btn-align { margin-left:10px; margin-top:-10px; height:56px !important}
.btn-spacing { margin-left: 70px }
.v-menu__content {
	min-width: 200px !important;
	max-width: 200px !important;
	width: 200px !important;
	right: 30px !important;
	left: calc(100% - 235px) !important;
}
</style>
